<template>
  <div>
    <div class="row">
      <div class="col s12">
          <p>
        <ul class="tabs" ref="tabs">
          <li class="tab s6"><a class="active" href="#perf">Performances</a></li>

        </ul>
          </p>
      </div>
      <PerformanceList id="perf" class="col s12" :user="user" />
    </div>
  </div>
</template>

<script>
import M from 'materialize-css'
import api from '@/api'
import PerformanceList from '@/components/records/PerformanceList'

export default {
  name: 'records',
  props: ['tab'],
  components: { PerformanceList },
  data: function () {
    return {
      user: undefined
    }
  },
  created () {
    this.user = api.getCurrentUser()
  },
  mounted () {
    var tabs = M.Tabs.init(this.$refs.tabs, {})
    if (this.tab) tabs.select(this.tab)
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Records.vue